import { ApiDocs } from '@/constants/apiDocuments';
import { Card } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { uniqueId } from 'lodash';
import ApiDocItem from '../ApiDocItem';

function SmsOTP() {
  const { t } = useTranslation();

  const apiEndpointsInfo = ApiDocs.smsOTP;

  return (
    <div className="sms-otp-docs mb-32">
      <div className="api-document__content__title">
        {t('api_page.documents.sms_otp.title')}
      </div>

      <Card>
        {apiEndpointsInfo.length > 0 &&
          apiEndpointsInfo.map((apiEndpoint) => (
            <ApiDocItem key={uniqueId()} {...apiEndpoint} />
          ))}
      </Card>
    </div>
  );
}

export default SmsOTP;
